const AnyFieldOptions = {
  OBJ: 'Object',
  ARR: 'Array',
  BOOL: 'Boolean',
  STRING: 'String',
  /*
   * Currently, NULL & NUMBER types are not supported in Custom Attributes, but it may be
   * supported in the future.
   */
  NUM: 'Number',
  INT: 'Integer',
  NULL: 'Null',
};

type AnyFieldOptionsType = typeof AnyFieldOptions[keyof typeof AnyFieldOptions];

const customAttributeTypes = {
  title: 'Data Type',
  values: [
    {
      text: AnyFieldOptions.OBJ,
      subtext: 'The value is an object.',
    },
    {
      text: AnyFieldOptions.ARR,
      subtext: 'The value is an array, which can contain multiple items.',
    },
    {
      text: AnyFieldOptions.BOOL,
      subtext: 'The value is `true` or `false`.',
    },
    {
      text: AnyFieldOptions.STRING,
      subtext:
        'The value is a string, such as "Coffee", "42", or "+14065551234".',
    },
    /*
     * Currently, NULL & NUMBER types are not supported in Custom Attributes, but it may be
     * supported in the future. To enable it, uncomment these blocks.
    {
      text: AnyFieldOptions.NUM,
      subtext: 'An integer or a floating-point number.',
    },
    {
      text: AnyFieldOptions.NULL,
      subtext:
        'A nonexistent value. In an API request this value will appear as `null`.',
    },
     */
  ],
};

/**
 * Transform an input value into a primitive type and field value
 * @param value ApiExplorerInputType
 * @returns [AnyFieldOptions, unknown] Primitive type and field value
 */
const transformValueToPrimitive = (value: unknown) => {
  if (value === undefined) {
    return [undefined, undefined];
  }
  if (typeof value === 'string' || typeof value === 'boolean') {
    const title =
      typeof value === 'string' ? AnyFieldOptions.STRING : AnyFieldOptions.BOOL;
    return [title, value];
  }
  if (Array.isArray(value)) {
    return [AnyFieldOptions.ARR, JSON.stringify(value)];
  }
  if (typeof value === 'object') {
    if (value === null) {
      return [AnyFieldOptions.NULL, value];
    }
    return [AnyFieldOptions.OBJ, JSON.stringify(value)];
  }
  try {
    return [AnyFieldOptions.OBJ, JSON.stringify(value)];
  } catch {
    return [AnyFieldOptions.OBJ, value];
  }
};

export {
  AnyFieldOptions,
  type AnyFieldOptionsType,
  customAttributeTypes,
  transformValueToPrimitive,
};
